<modal (closeOut)="close()" (close)="close()" minHeight="375" width="600">
  <modal-header>
    <span>{{ strings.insertImage }}</span>
  </modal-header>

  <modal-body>
    <div class="content">
      <div>
        <kendo-buttongroup selection="single">
          <button kendoButton
            fillMode="solid"
            themeColor="tertiary"
            [toggleable]="true"
            [selected]="true"
          (selectedChange)="tabChange(insertImgTabs.UploadImage)">{{ strings.uploadImage }}</button>
          <button kendoButton
            fillMode="solid"
            themeColor="tertiary"
            [toggleable]="true"
            [selected]="false"
          (selectedChange)="tabChange(insertImgTabs.AttachUrl)">{{ strings.attachUrl }}</button>
          <button kendoButton
            fillMode="solid"
            themeColor="tertiary"
            [toggleable]="true"
            [selected]="false"
            (selectedChange)="tabChange(insertImgTabs.ManageImages)">{{ strings.manageImages }}</button>
        </kendo-buttongroup>
      </div>
      <div>
        <div [hidden]="!isUploadTab">
          @if (!uploadedImageFileName) {
            <ti-drag-drop
              [multiple]="false"
              [actionMode]="'single'"
              [formatSupport]="imageDragDropFormatSupport"
              [maxSize]="maxImgSize()"
              [description]="uploadDropDescription()"
              (transferCompleted)="onImageDropTransfer($event)">
            </ti-drag-drop>
          } @else {
            <kendo-chip
              [removable]="true"
              fillMode="solid"
              themeColor="base"
              (remove)="onUploadedImageChipRemove()">
              <span class="ti-primary-label" title="{{ uploadedImageFileName }}">{{ uploadedImageFileName }}</span>
            </kendo-chip>
          }
        </div>
  
        <div [hidden]="activeTab !== insertImgTabs.AttachUrl">
          <div class="form-group" [formGroup]="form">
            <label for="url">{{ strings.url }}</label>
            <input
              id="url"
              formControlName="url"
              kendoTextBox
              type="text"
              placeholder="{{strings.linkPlaceholder}}"/>
            @if (getError('url'); as error) {
              <div class="error-message">{{ error }}</div>
            }
          </div>
        </div>
  
        @if (isManageImagesTab) {
          <div class="manage-images">
            @if (!loading && images.length) {
              <div class="manage-images-list">
                @for (image of images; track trackByFunc($index, image)) {
                  <div class="manage-images-item">
                    <img [src]="image.Url" alt="{{image.Name || strings.imagePreview}}">
                    <div class="manage-images-actions">
                      <i class="fa fa-trash" title="{{miscStrings.delete}}" (click)="deleteImage(image)"></i>
                      <i class="fa fa-plus" title="{{strings.insert}}" (click)="insertImageIntoEditor(image.Url)"></i>
                    </div>
                  </div>
                }
              </div>
            } @else {
              @if (!loading) {
                <span class="no-images-text">{{ strings.noImagesFound }}</span>
              }
            }
            @if (loading) {
              <ti-spinner></ti-spinner>
            }
          </div>
        }
      </div>
    </div>
  </modal-body>

  @if (!isManageImagesTab) {
    <modal-actions>
      <button kendoButton fillMode="solid" themeColor="tertiary" (click)="close()">{{ miscStrings.cancel }}</button>
      <button kendoButton fillMode="solid" themeColor="primary" [disabled]="isDisabledBtn" (click)="insert()">{{ strings.insert }}</button>
    </modal-actions>
  }
</modal>

